export { default as initializeIsMsHighContrastState } from './util/initializeIsMsHighContrastState';
export { default as getIsMsHighContrast } from './selectors/getIsMsHighContrast';
